import { isEmpty } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Icon from '../../../Icon'

const StepContentWrapper = styled.div`
  display: flex;
  z-index: 5;
  flex-direction: column;
  .stepbar__container.vertical & {
    flex-direction: row;
  }
  align-items: center;
  justify-content: center;
`
type TStepTitle = {
  textColor?: string
}
const StepTitle = styled.div<TStepTitle>`
  height: 40px;
  .stepbar__container.vertical & {
    margin-left: 5px;
    height: auto;
  }
  color: ${({ textColor }) => textColor || 'inherit'};
`

const IconWrapper = styled.div`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eaf0f4;
  color: #99a2a8;
  border: 1px solid #eaf0f4;
`

type TStepContent = {
  icon?: string
  title?: string
  titleShort?: string
  color?: string
  textColor?: string
}

const StepContent = (props: TStepContent): React.ReactElement => {
  const { icon, title, titleShort = '', color, textColor } = props
  return (
    <StepContentWrapper>
      <IconWrapper className="stepbar__item-icon-wrapper" color={color}>
        <Icon icon={icon} size="1.5" />
      </IconWrapper>
      <StepTitle className="d-none d-md-block" textColor={textColor}>
        {title}
      </StepTitle>
      <StepTitle className="d-block d-md-none" textColor={textColor}>
        {!isEmpty(titleShort) ? titleShort : title}
      </StepTitle>
    </StepContentWrapper>
  )
}

export default StepContent
